/* eslint-disable ember/no-computed-properties-in-native-classes */
import { computed } from '@ember/object';
import Component from '@glimmer/component';
import { PrismDataBar } from '@mylighthouse/prism-ember';
import type { BarData } from '@mylighthouse/prism-ember/types/components/prism/data-bar';
import getProgressBarPercentage from 'lumen/utils/revenue-insight/get-progress-bar-percentage';

export interface TooltipBarGraphMultipleValue {
  backgroundColour: string;
  isStriped: boolean;
  maxValue: number;
  value: number;
}

interface HotelAndMarketRevenueInsightTooltipsTooltipBarGraphMultipleSignature {
  Args: {
    values: TooltipBarGraphMultipleValue[] | null;
  };
}

export default class HotelAndMarketRevenueInsightTooltipsTooltipBarGraphMultiple extends Component<HotelAndMarketRevenueInsightTooltipsTooltipBarGraphMultipleSignature> {
  @computed('args.values.@each.{value,maxValue,backgroundColour}')
  get progressBarData(): BarData[] {
    const { values } = this.args;
    const progressBarData: TooltipBarGraphMultipleValue[] = values ?? [];

    return progressBarData.map((datum) => {
      const { backgroundColour, isStriped, maxValue, value } = datum;

      return {
        backgroundColor: backgroundColour,
        isStriped,
        widthPercentage: getProgressBarPercentage(value, maxValue),
      };
    });
  }

  <template><PrismDataBar @data={{this.progressBarData}} /></template>
}
